import { equals } from 'ramda';
import {
  DEEDSY_SH_COBORROWER,
} from 'src/services/constants';


//Add a todo saying We support only 1 co borrower.  When we move to support more coborrower then we will have to prefix by
//Coborrower_${loanRoleId}

export const mkCompletedCondition = (loanRole: any, status: any) => {
  const role = equals(DEEDSY_SH_COBORROWER, loanRole)
    ? `Coborrower`
    : 'Borrower';
  return `${role}.${status}`;
};
